<template>
  <div
    class="i-category-select"
  >
    <i-select
      :icon-behavior="'focus'"
      :value="selectedCategory"
      :options="categoryOptions"
      :fallback-value="fallbackValue"
      :clean-on-foucus="true"
      :enable-filter="false"
      @select="onSubmit"
      @submit="onSubmit"
      @input="onInput"
    >
      <i
        slot="icon"
        class="isif isif-arrow-down"
      />
    </i-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ISelect from './ISelect.vue'
import { COMPANY, CATEGORY_OPTIONS } from '~js/constants'

export default {
  name: 'ICategorySelect',
  components: {
    ISelect
  },
  data () {
    return {
      COMPANY
    }
  },
  computed: {
    ...mapGetters([
      'selectedCategory',
      'headquarter',
      'categoryOptions'
    ]),
    fallbackValue () {
      return CATEGORY_OPTIONS[0]
    }
  },
  methods: {
    ...mapActions([
      'setSelectedCategory',
      'showSearchs',
      'closeInformation',
      'closeShare',
      'closeMarkerInfo',
      'closeLocation',
      'closeComments'
    ]),
    onInput (val) {
      this.setSelectedCategory(val)
    },
    onSubmit () {
      this.showSearchs()
      this.closeInformation()
      this.closeShare()
      this.closeMarkerInfo()
      this.closeLocation()
      this.closeComments()
    }
  }
}
</script>

<style lang="stylus" scoped>
.i-category-select {
  display: flex
  align-items: center
  justify-content: center

  select {
    background: transparent
    border-width: 0
    outline: none
    color: #fff;
    padding: 3px 10px

    &:hover {
      cursor: pointer
    }
  }
  .isif-arrow-down {
    margin-top: 15px // (.i-select-input height - 16) / 2
    color: #212121
  }
}

</style>
